const coreProgramMeta = state => state.coreProgramMeta;
const programSettingsCopy = state => state.programSettingsCopy;
const maps = state => state.maps;
const programMapsLoaded = state => state.programMapsLoaded;
const programTeams = state => state.programTeams;
const programTeamsLoaded = state => state.programTeamsLoaded;
const programTeamsResponseObject = state => state.programTeamsResponseObject;
const programOrganizations = state => state.programOrganizations;
const programOrganizationsLoaded = state => state.programOrganizationsLoaded;
const membersResponseObject = state => state.membersResponseObject;
const adminMembersResponseObject = state => state.adminMembersResponseObject;
const membersLoaded = state => state.membersLoaded;
const membersInitialLoadComplete = state => state.membersInitialLoadComplete;
const challenges = state => state.challenges;
const challengesLoaded = state => state.challengesLoaded;
const allChallenges = state => state.allChallenges;
const allChallengesLoaded = state => state.allChallengesLoaded;
const activeChallenges = state => state.activeChallenges;
const activeChallengesLoaded = state => state.activeChallengesLoaded;
const pendingChallenges = state => state.pendingChallenges;
const pendingChallengesLoaded = state => state.pendingChallengesLoaded;
const archivedChallenges = state => state.archivedChallenges;
const archivedChallengesLoaded = state => state.archivedChallengesLoaded;
const featuredChallenges = state => state.featuredChallenges;
const featuredChallengesLoaded = state => state.featuredChallengesLoaded;
const allFeaturedChallenges = state => state.allFeaturedChallenges;
const allFeaturedChallengesLoaded = state => state.allFeaturedChallengesLoaded;
const featuredChallenge = state => state.featuredChallenge;
const currentFeaturedChallengeLoaded = state =>
  state.currentFeaturedChallengeLoaded;
const programLoaded = state => state.programLoaded;
const activities = state => state.activities;
const activitiesLoaded = state => state.activitiesLoaded;
const isJournalLastPage = state => state.isJournalLastPage;
const journals = state => state.journals;
const journalsLoaded = state => state.journalsLoaded;
const stepData = state => state.stepData;
const stepDataLoaded = state => state.stepDataLoaded;
const leaderboard = state => state.leaderboard;
const leaderboardLoaded = state => state.leaderboardLoaded;
const aggregateData = state => state.aggregateData;
const aggregateDataLoaded = state => state.aggregateDataLoaded;
const isThriveProduct = state => state.isThriveProduct;
const isEngageProduct = state => state.isEngageProduct;
const isActivateProduct = state => state.isActivateProduct;
const isProTier = state => state.isProTier;
const isPlusTier = state => state.isPlusTier;
const isCoreTier = state => state.isCoreTier;
const isActivity = state => state.isActivity;
const isWellness = state => state.isWellness;
const isTeamsFeatureOn = state => !state.coreProgramMeta.teamsOff;
const isPointsFeatureOn = state => state.coreProgramMeta.points;
const programQuestions = state => state.programQuestions;
const programQuestionsLoaded = state => state.programQuestionsLoaded;
const isIncentiveIntegrationOn = state => state.isIncentiveIntegrationOn;

export default {
  isProTier,
  isPlusTier,
  isCoreTier,
  isThriveProduct,
  isEngageProduct,
  isActivateProduct,
  isActivity,
  isWellness,
  isTeamsFeatureOn,
  isPointsFeatureOn,
  coreProgramMeta,
  programSettingsCopy,
  maps,
  programMapsLoaded,
  programTeams,
  programTeamsLoaded,
  programTeamsResponseObject,
  programOrganizations,
  programOrganizationsLoaded,
  membersResponseObject,
  adminMembersResponseObject,
  membersLoaded,
  membersInitialLoadComplete,
  challenges,
  featuredChallenges,
  featuredChallengesLoaded,
  allFeaturedChallenges,
  allFeaturedChallengesLoaded,
  featuredChallenge,
  currentFeaturedChallengeLoaded,
  programLoaded,
  challengesLoaded,
  activities,
  activitiesLoaded,
  isJournalLastPage,
  journals,
  journalsLoaded,
  stepData,
  stepDataLoaded,
  leaderboard,
  leaderboardLoaded,
  aggregateData,
  aggregateDataLoaded,
  activeChallenges,
  activeChallengesLoaded,
  pendingChallenges,
  pendingChallengesLoaded,
  archivedChallenges,
  archivedChallengesLoaded,
  allChallenges,
  allChallengesLoaded,
  programQuestions,
  programQuestionsLoaded,
  isIncentiveIntegrationOn
};
